import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        light: true,
        themes: {
            light: {
                primary: '#1b92da',
                error: '#C25B51',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                success: '#b71c1c',
                info: '#2196F3',
                warning: '#C25B51',
            },
        },
    },
  icons: {
    iconfont: 'mdi',
  },
});
